module.exports = __webpack_public_path__ + "img/icon-lizard.7d2e0b18.svg";